import React from 'react';


const FixedAlertTextInfo = ({ text }) => {
  return(
    <div style={styles.constainerStyle}>
      <p style={styles.textStyle} className="text-justify no-margin">
        {text}
      </p>
    </div>
  )
}

const styles = {
  constainerStyle:{
    backgroundColor: "#00ACC1",
    fontWeight: "bold",
    color: "#FFFFFF",
    fontSize: "95%",
    padding: "8px",
    margin: "0 auto",
    float: "none"
  },
  textStyle :{
    fontSize: "1.05em"
  }
};

export default FixedAlertTextInfo;
